module.exports = __webpack_public_path__ + "static/media/twitter_kurisu.e50f7854.jpg";